import React from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';
import { Classes } from 'jss';

interface ButtonProps {
  children: React.ReactNode;
  variant: 'primary' | 'secondary';
  onClick?: () => void;
  additionalClass?: Classes<any>;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ children, variant, onClick, disabled = false }) => {
  const classes = useStyles();

  return (
    <button
      className={`${variant === 'primary' ? classes.primary : classes.secondary} ${classes.button}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

const useStyles = createUseStyles({
  button: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    display: 'inline-flex',
    width: 'fit-content',
    borderRadius: 40,
    fontSize: 16,
    border: 'none',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:disabled': {
      cursor: 'not-allowed',
      color: theme.colors.grey,
    },
  },
  primary: {
    backgroundColor: theme.colors.roseMain,
    padding: '16px 32px 16px 32px',
    color: 'white',
    '&:active:not(:disabled)': {
      backgroundColor: theme.colors.functionalRed,
    },
  },
  secondary: {
    backgroundColor: theme.colors.contrastWhite,
    padding: '15px 20px 15px 20px',
    color: theme.colors.roseMain,
    '&:active:not(:disabled)': {
      backgroundColor: theme.colors.functionalRedLight,
    },
  },
});

export default Button;
